import { ClientSignatureModel, ISignature } from "./client-signature.model";

export class ClientSignatureSubmitInfoModel {
    clientSignature: SaveClientSignatureModel = new SaveClientSignatureModel;
    code: string = "";
    tenantId?: string = "";
}

export class SaveClientSignatureModel implements ISignature {
    signaturePointsString?: string;
    initialsPointsString?: string;
    initials?: string;
    signature?: string;
    clientId?: string;
}
